<script lang="ts">
  import Tab from "../../../components/Tab/Tab.svelte";
  import Tabs from "../../../components/Tab/Tabs.svelte";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import QualityDocumentManager from "../../QualityDocument/QualityDocumentManager.svelte";

  enum QualityAnalysisPage {
    Ambientali = 1,
    Carcasse,
    Salumi,
  }

  let currentTab: QualityAnalysisPage = QualityAnalysisPage.Ambientali;
</script>

<QualityLayout>
  <div class="quality-analysis-main-controls">
    <div class="analysis-tabs">
      <Tabs>
        <Tab
          label="Analisi Ambientali"
          active={currentTab == QualityAnalysisPage.Ambientali}
          on:click={(_) => {
            currentTab = QualityAnalysisPage.Ambientali;
          }}
        />
        <Tab
          label="Analisi Carcasse"
          active={currentTab == QualityAnalysisPage.Carcasse}
          on:click={(_) => {
            currentTab = QualityAnalysisPage.Carcasse;
          }}
        />
        <Tab
          label="Analisi Salumi"
          active={currentTab == QualityAnalysisPage.Salumi}
          on:click={(_) => {
            currentTab = QualityAnalysisPage.Salumi;
          }}
        />
      </Tabs>
    </div>
  </div>

  {#if currentTab == QualityAnalysisPage.Ambientali}
    <QualityDocumentManager entityName="analisi ambientali" clfDocTypeCode="ANALAMBIEN" withVersion={false} comparisonUrl="/limiti/LIMITI_SUPERFICI.pdf" />
  {/if}

  {#if currentTab == QualityAnalysisPage.Carcasse}
    <QualityDocumentManager entityName="analisi carcasse" clfDocTypeCode="ANALCARCAS" withVersion={false} comparisonUrl="/limiti/LIMITI_CARCASSE.pdf" />
  {/if}

  {#if currentTab == QualityAnalysisPage.Salumi}
    <QualityDocumentManager entityName="analisi salumi" clfDocTypeCode="ANALSALUMI" withVersion={false} comparisonUrl="/limiti/LIMITI_PREPARAZIONI.pdf" />
  {/if}
</QualityLayout>

<style>
  .quality-analysis-main-controls {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }
  .quality-analysis-main-controls .analysis-tabs {
    flex: 1;
  }
</style>
